import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "max-w-4xl mx-auto px-6 py-16" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-32"
}
const _hoisted_3 = {
  key: 1,
  class: "text-center"
}
const _hoisted_4 = { class: "w-14 h-14 mx-auto mb-6 bg-primary-purple/10 rounded-xl flex items-center justify-center" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "max-w-2xl mx-auto mb-16" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 text-left"
}
const _hoisted_10 = { class: "text-left" }
const _hoisted_11 = { class: "flex items-center justify-between mb-4" }
const _hoisted_12 = { class: "flex items-center gap-2" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_16 = { class: "text-left mt-12" }
const _hoisted_17 = { class: "flex items-center justify-between mb-4" }
const _hoisted_18 = { class: "flex items-center gap-2" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_21 = {
  key: 0,
  class: "flex justify-center py-8"
}
const _hoisted_22 = {
  key: 1,
  class: "space-y-3"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "flex items-start justify-between" }
const _hoisted_25 = { class: "flex items-start gap-3 flex-1" }
const _hoisted_26 = { class: "w-8 h-8 bg-primary-purple/10 rounded flex items-center justify-center flex-shrink-0" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "flex-1 min-w-0" }
const _hoisted_29 = { class: "flex items-center gap-2 flex-wrap" }
const _hoisted_30 = { class: "text-sm font-medium text-gray-900 truncate" }
const _hoisted_31 = { class: "inline-flex items-center gap-1 px-2.5 py-0.5 text-xs font-medium rounded-md bg-green-100 text-green-700" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = { class: "flex items-center gap-3 mt-1 text-xs text-gray-500" }
const _hoisted_34 = { class: "flex items-center gap-1" }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { class: "flex items-center gap-1" }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = {
  key: 0,
  class: "text-xs text-gray-500 mt-2 line-clamp-2"
}
const _hoisted_39 = { class: "flex items-center gap-1 px-3 py-1 bg-primary-purple text-white text-xs font-medium rounded-full flex-shrink-0 ml-3" }
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = {
  key: 0,
  class: "flex justify-center pt-4"
}
const _hoisted_42 = ["disabled"]
const _hoisted_43 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_44 = { key: 1 }
const _hoisted_45 = {
  key: 2,
  class: "text-center py-8 bg-white rounded-lg border border-gray-200"
}
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = { key: 2 }
const _hoisted_48 = { class: "mb-8" }
const _hoisted_49 = ["placeholder"]
const _hoisted_50 = ["disabled"]
const _hoisted_51 = { class: "flex items-center justify-between mb-6" }
const _hoisted_52 = { class: "text-xl font-semibold text-gray-900" }
const _hoisted_53 = { class: "text-primary-purple" }
const _hoisted_54 = { class: "text-gray-500 font-normal" }
const _hoisted_55 = { class: "text-sm text-gray-500 mt-1" }
const _hoisted_56 = { class: "flex items-center gap-3" }
const _hoisted_57 = { class: "bg-white rounded-lg p-6 max-w-sm w-full mx-4" }
const _hoisted_58 = { class: "text-sm text-gray-500 mb-4" }
const _hoisted_59 = { class: "mb-4" }
const _hoisted_60 = { class: "flex justify-end gap-2" }
const _hoisted_61 = ["disabled"]
const _hoisted_62 = {
  key: 1,
  class: "mb-6 p-4 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm"
}
const _hoisted_63 = {
  key: 2,
  class: "flex items-center justify-center py-16"
}
const _hoisted_64 = {
  key: 3,
  class: "flex flex-col items-center justify-center py-16 text-center"
}
const _hoisted_65 = ["innerHTML"]
const _hoisted_66 = {
  key: 4,
  class: "space-y-4"
}
const _hoisted_67 = { class: "p-4 border-b border-gray-100" }
const _hoisted_68 = { class: "flex items-start justify-between" }
const _hoisted_69 = { class: "flex items-start gap-3" }
const _hoisted_70 = { class: "w-8 h-8 bg-primary-purple/10 rounded flex items-center justify-center flex-shrink-0" }
const _hoisted_71 = ["innerHTML"]
const _hoisted_72 = { class: "flex-1" }
const _hoisted_73 = { class: "flex items-center gap-2 flex-wrap" }
const _hoisted_74 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_75 = { class: "inline-flex items-center gap-1 px-2.5 py-0.5 text-xs font-medium rounded-md bg-green-100 text-green-700" }
const _hoisted_76 = ["innerHTML"]
const _hoisted_77 = { class: "flex items-center gap-3 mt-1 text-xs text-gray-500" }
const _hoisted_78 = { class: "flex items-center gap-1" }
const _hoisted_79 = ["innerHTML"]
const _hoisted_80 = { class: "flex items-center gap-1" }
const _hoisted_81 = ["innerHTML"]
const _hoisted_82 = { class: "flex items-center gap-1 px-3 py-1 bg-primary-purple text-white text-xs font-medium rounded-full" }
const _hoisted_83 = ["innerHTML"]
const _hoisted_84 = { class: "p-4 relative" }
const _hoisted_85 = { class: "relative overflow-hidden max-h-[120px]" }
const _hoisted_86 = { class: "text-sm text-gray-600 leading-relaxed" }
const _hoisted_87 = { class: "flex justify-end mt-2" }
const _hoisted_88 = ["onClick"]
const _hoisted_89 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_WatchlistCard = _resolveComponent("WatchlistCard")!
  const _component_WatchlistDetailsModal = _resolveComponent("WatchlistDetailsModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hasSearched && _ctx.isSearching)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[22] || (_cache[22] = [
          _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-primary-purple mx-auto mb-4" }, null, -1),
          _createElementVNode("p", { class: "text-gray-500" }, "Searching transcripts...", -1)
        ]))]))
      : (!_ctx.hasSearched)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", {
                innerHTML: _ctx.SEARCH_ICON,
                class: "text-primary-purple"
              }, null, 8, _hoisted_5)
            ]),
            _cache[32] || (_cache[32] = _createElementVNode("h1", { class: "text-3xl font-bold text-gray-900 mb-8" }, "Search Anything", -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: _normalizeClass(["flex items-center bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden", {
            'ring-2 ring-primary-purple border-transparent': _ctx.isSearchFocused,
            'ring-2 ring-red-300 border-transparent': _ctx.searchError,
          }])
              }, [
                _withDirectives(_createElementVNode("input", {
                  ref: "searchInput",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                  type: "text",
                  placeholder: "What features are experts talking about most?",
                  class: "flex-1 px-5 py-4 text-gray-900 placeholder-gray-400 focus:outline-none",
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.performSearch && _ctx.performSearch(...args)), ["enter"])),
                  onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isSearchFocused = true)),
                  onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isSearchFocused = false))
                }, null, 544), [
                  [_vModelText, _ctx.searchQuery]
                ]),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.performSearch && _ctx.performSearch(...args))),
                  disabled: !_ctx.searchQuery.trim() || _ctx.isSearching,
                  class: "px-5 py-4 text-gray-400 hover:text-primary-purple transition-colors disabled:opacity-50"
                }, [
                  _createElementVNode("span", { innerHTML: _ctx.SEARCH_ICON_SMALL }, null, 8, _hoisted_8)
                ], 8, _hoisted_7)
              ], 2),
              (_ctx.searchError)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.searchError), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", {
                    innerHTML: _ctx.EYE_ICON,
                    class: "text-gray-600"
                  }, null, 8, _hoisted_13),
                  _cache[23] || (_cache[23] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900" }, "My Watchlist", -1))
                ]),
                _createVNode(_component_router_link, {
                  to: { name: 'InsightsWatchlist' },
                  class: "flex items-center gap-1 text-sm font-medium text-primary-purple hover:underline"
                }, {
                  default: _withCtx(() => [
                    _cache[24] || (_cache[24] = _createTextVNode(" See All ", -1)),
                    _createElementVNode("span", { innerHTML: _ctx.ARROW_RIGHT_ICON }, null, 8, _hoisted_14)
                  ]),
                  _: 1
                })
              ]),
              _cache[31] || (_cache[31] = _createElementVNode("p", { class: "text-sm text-gray-500 mb-6" }, " Your recent searches that you've added your library to get updates. ", -1)),
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.watchlistItems, (item) => {
                  return (_openBlock(), _createBlock(_component_WatchlistCard, {
                    key: item.id,
                    item: item,
                    "open-menu-id": _ctx.openMenuId,
                    onClick: ($event: any) => (_ctx.handleSeeAll(item)),
                    onToggleMenu: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openMenuId = _ctx.openMenuId === $event ? null : $event)),
                    onViewDetails: _cache[6] || (_cache[6] = ($event: any) => {
              _ctx.viewDetailsItem = $event;
              _ctx.openMenuId = null;
            }),
                    onRemove: _cache[7] || (_cache[7] = ($event: any) => {
              _ctx.handleRemoveFromWatchlist($event);
              _ctx.openMenuId = null;
            })
                  }, null, 8, ["item", "open-menu-id", "onClick"]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("span", {
                      innerHTML: _ctx.CLOCK_ICON,
                      class: "text-gray-600"
                    }, null, 8, _hoisted_19),
                    _cache[25] || (_cache[25] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900" }, "Recent Calls", -1)),
                    (_ctx.recentCalls.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, " (" + _toDisplayString(_ctx.recentCalls.length) + _toDisplayString(_ctx.hasMoreRecentCalls ? "+" : "") + ") ", 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _cache[30] || (_cache[30] = _createElementVNode("p", { class: "text-sm text-gray-500 mb-6" }, " Browse your latest call transcripts across all programs. ", -1)),
                (_ctx.isLoadingRecentCalls && _ctx.recentCalls.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[26] || (_cache[26] = [
                      _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-b-2 border-primary-purple" }, null, -1)
                    ]))]))
                  : (_ctx.recentCalls.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentCalls, (call) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: call.id,
                            onClick: ($event: any) => (_ctx.viewTranscript(call.id)),
                            class: "bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md hover:border-primary-purple/30 transition-all cursor-pointer"
                          }, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("span", {
                                    innerHTML: _ctx.PERSON_ICON,
                                    class: "w-5 h-5 text-primary-purple"
                                  }, null, 8, _hoisted_27)
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("h3", _hoisted_30, _toDisplayString(call.callTitle || "Untitled Call"), 1),
                                    _createElementVNode("span", _hoisted_31, [
                                      _createElementVNode("span", {
                                        innerHTML: _ctx.CHECK_ICON,
                                        class: "w-3 h-3"
                                      }, null, 8, _hoisted_32),
                                      _cache[27] || (_cache[27] = _createTextVNode(" Closed ", -1))
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("span", _hoisted_34, [
                                      _createElementVNode("span", {
                                        innerHTML: _ctx.CALENDAR_ICON,
                                        class: "w-3 h-3 opacity-70"
                                      }, null, 8, _hoisted_35),
                                      _createTextVNode(" " + _toDisplayString(_ctx.formatDate(call.processedAt)), 1)
                                    ]),
                                    _createElementVNode("span", _hoisted_36, [
                                      _createElementVNode("span", {
                                        innerHTML: _ctx.PEOPLE_ICON,
                                        class: "w-3.5 h-3.5 opacity-70"
                                      }, null, 8, _hoisted_37),
                                      _createTextVNode(" " + _toDisplayString(_ctx.getSpeakerCount(call)) + " Attendees ", 1)
                                    ])
                                  ]),
                                  (call.callBrief)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString(call.callBrief), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("span", _hoisted_39, [
                                _createElementVNode("span", {
                                  innerHTML: _ctx.PLAY_ICON,
                                  class: "w-3 h-3"
                                }, null, 8, _hoisted_40),
                                _createTextVNode(" " + _toDisplayString(_ctx.formatDuration(call.durationSeconds)), 1)
                              ])
                            ])
                          ], 8, _hoisted_23))
                        }), 128)),
                        (_ctx.hasMoreRecentCalls)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              _createElementVNode("button", {
                                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.loadMoreRecentCalls && _ctx.loadMoreRecentCalls(...args))),
                                disabled: _ctx.isLoadingRecentCalls,
                                class: "px-6 py-2 text-sm font-medium text-primary-purple border border-primary-purple rounded-lg hover:bg-primary-purple/5 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                              }, [
                                (_ctx.isLoadingRecentCalls)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_43, [...(_cache[28] || (_cache[28] = [
                                      _createElementVNode("span", { class: "animate-spin rounded-full h-4 w-4 border-b-2 border-primary-purple" }, null, -1),
                                      _createTextVNode(" Loading... ", -1)
                                    ]))]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_44, "Load More"))
                              ], 8, _hoisted_42)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createElementVNode("div", {
                          innerHTML: _ctx.EMPTY_SEARCH_ICON,
                          class: "mx-auto mb-3 text-gray-300 w-12 h-12"
                        }, null, 8, _hoisted_46),
                        _cache[29] || (_cache[29] = _createElementVNode("p", { class: "text-sm text-gray-500" }, "No recent calls found", -1))
                      ]))
              ])
            ]),
            _createVNode(_component_WatchlistDetailsModal, {
              show: !!_ctx.viewDetailsItem,
              item: _ctx.viewDetailsItem,
              "program-name": _ctx.userStore.selectedProgram?.name ?? '',
              onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.viewDetailsItem = null)),
              onUpdated: _cache[10] || (_cache[10] = ($event: any) => (_ctx.viewDetailsItem = null))
            }, null, 8, ["show", "item", "program-name"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", {
                class: _normalizeClass(["flex items-center bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden", {
            'ring-2 ring-primary-purple border-transparent': _ctx.isSearchFocused,
          }])
              }, [
                _withDirectives(_createElementVNode("input", {
                  ref: "searchInput",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.searchQuery) = $event)),
                  type: "text",
                  placeholder: _ctx.lastSearchQuery,
                  class: "flex-1 px-5 py-4 text-gray-900 placeholder-gray-400 focus:outline-none",
                  onKeyup: _cache[12] || (_cache[12] = _withKeys(
//@ts-ignore
(...args) => (_ctx.performSearch && _ctx.performSearch(...args)), ["enter"])),
                  onFocus: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isSearchFocused = true)),
                  onBlur: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isSearchFocused = false))
                }, null, 40, _hoisted_49), [
                  [_vModelText, _ctx.searchQuery]
                ]),
                _createElementVNode("button", {
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.performSearch && _ctx.performSearch(...args))),
                  disabled: !_ctx.searchQuery.trim() || _ctx.isSearching,
                  class: "px-6 py-4 bg-primary-purple text-white font-medium hover:bg-primary-purple/90 transition-colors disabled:opacity-50"
                }, " Search ", 8, _hoisted_50)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_52, [
                  _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.totalResults) + " results", 1),
                  _createElementVNode("span", _hoisted_54, " for \"" + _toDisplayString(_ctx.lastSearchQuery) + "\"", 1)
                ]),
                _createElementVNode("p", _hoisted_55, " Found in " + _toDisplayString(_ctx.searchTimeMs) + "ms ", 1)
              ]),
              _createElementVNode("div", _hoisted_56, [
                (_ctx.totalResults > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showAddToWatchlistModal = true)),
                      class: "text-sm font-medium text-primary-purple hover:underline"
                    }, " Add to Watchlist "))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.clearResults && _ctx.clearResults(...args))),
                  class: "text-sm text-gray-500 hover:text-gray-700 underline"
                }, " Clear results ")
              ])
            ]),
            (_ctx.showAddToWatchlistModal)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
                  onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.showAddToWatchlistModal = false), ["self"]))
                }, [
                  _createElementVNode("div", _hoisted_57, [
                    _cache[35] || (_cache[35] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900 mb-4" }, " Add to Watchlist ", -1)),
                    _createElementVNode("p", _hoisted_58, " Get updates for \"" + _toDisplayString(_ctx.lastSearchQuery) + "\" ", 1),
                    _createElementVNode("div", _hoisted_59, [
                      _cache[34] || (_cache[34] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " Update frequency ", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.addWatchlistFrequency) = $event)),
                        class: "w-full px-3 py-2 border border-gray-300 rounded-md"
                      }, [...(_cache[33] || (_cache[33] = [
                        _createElementVNode("option", { value: "daily" }, "Daily", -1),
                        _createElementVNode("option", { value: "weekly" }, "Weekly", -1),
                        _createElementVNode("option", { value: "monthly" }, "Monthly", -1)
                      ]))], 512), [
                        [_vModelSelect, _ctx.addWatchlistFrequency]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("button", {
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showAddToWatchlistModal = false)),
                        class: "px-4 py-2 text-gray-600 hover:text-gray-800"
                      }, " Cancel "),
                      _createElementVNode("button", {
                        onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.handleAddToWatchlist && _ctx.handleAddToWatchlist(...args))),
                        disabled: _ctx.addToWatchlistLoading,
                        class: "px-4 py-2 bg-primary-purple text-white rounded-md hover:bg-primary-purple/90 disabled:opacity-50"
                      }, _toDisplayString(_ctx.addToWatchlistLoading ? "Adding..." : "Add"), 9, _hoisted_61)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.searchError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(_ctx.searchError), 1))
              : _createCommentVNode("", true),
            (_ctx.isSearching)
              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [...(_cache[36] || (_cache[36] = [
                  _createElementVNode("div", { class: "animate-spin rounded-full h-10 w-10 border-b-2 border-primary-purple" }, null, -1)
                ]))]))
              : (_ctx.searchResults.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                    _createElementVNode("div", {
                      innerHTML: _ctx.EMPTY_SEARCH_ICON,
                      class: "mb-4 text-gray-300"
                    }, null, 8, _hoisted_65),
                    _cache[37] || (_cache[37] = _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 mb-2" }, "No results found", -1)),
                    _cache[38] || (_cache[38] = _createElementVNode("p", { class: "text-gray-500" }, "Try adjusting your search terms", -1))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_66, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (result) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: result.transcriptId,
                        class: "bg-white rounded-lg border border-gray-200 overflow-hidden hover:shadow-md transition-shadow"
                      }, [
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("div", _hoisted_68, [
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("div", _hoisted_70, [
                                _createElementVNode("span", {
                                  innerHTML: _ctx.PERSON_ICON,
                                  class: "w-5 h-5 text-primary-purple"
                                }, null, 8, _hoisted_71)
                              ]),
                              _createElementVNode("div", _hoisted_72, [
                                _createElementVNode("div", _hoisted_73, [
                                  _createElementVNode("h3", _hoisted_74, _toDisplayString(result.callTitle || "Untitled Call"), 1),
                                  _createElementVNode("span", _hoisted_75, [
                                    _createElementVNode("span", {
                                      innerHTML: _ctx.CHECK_ICON,
                                      class: "w-3 h-3"
                                    }, null, 8, _hoisted_76),
                                    _cache[39] || (_cache[39] = _createTextVNode(" Closed ", -1))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_77, [
                                  _createElementVNode("span", _hoisted_78, [
                                    _createElementVNode("span", {
                                      innerHTML: _ctx.CALENDAR_ICON,
                                      class: "w-3 h-3 opacity-70"
                                    }, null, 8, _hoisted_79),
                                    _createTextVNode(" " + _toDisplayString(_ctx.formatDate(result.processedAt)), 1)
                                  ]),
                                  _createElementVNode("span", _hoisted_80, [
                                    _createElementVNode("span", {
                                      innerHTML: _ctx.PEOPLE_ICON,
                                      class: "w-3.5 h-3.5 opacity-70"
                                    }, null, 8, _hoisted_81),
                                    _createTextVNode(" " + _toDisplayString(_ctx.getAttendeeCount(result)) + " Attendees ", 1)
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("span", _hoisted_82, [
                              _createElementVNode("span", {
                                innerHTML: _ctx.PLAY_ICON,
                                class: "w-3 h-3"
                              }, null, 8, _hoisted_83),
                              _createTextVNode(" " + _toDisplayString(_ctx.formatDuration(result.durationSeconds)), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_84, [
                          _createElementVNode("div", _hoisted_85, [
                            _createElementVNode("p", _hoisted_86, [
                              _cache[40] || (_cache[40] = _createElementVNode("span", { class: "font-semibold" }, "Call Brief:", -1)),
                              _createTextVNode(" " + _toDisplayString(result.callBrief ||
                  result.snippet ||
                  "No summary available for this call."), 1)
                            ]),
                            _cache[41] || (_cache[41] = _createElementVNode("div", { class: "absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent pointer-events-none" }, null, -1))
                          ]),
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.viewTranscript(result.transcriptId)),
                              class: "flex items-center gap-1 text-sm font-medium text-primary-purple hover:underline"
                            }, [
                              _cache[42] || (_cache[42] = _createTextVNode(" See Details ", -1)),
                              _createElementVNode("span", {
                                innerHTML: _ctx.ARROW_RIGHT_ICON,
                                class: "w-4 h-4"
                              }, null, 8, _hoisted_89)
                            ], 8, _hoisted_88)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
          ]))
  ]))
}